import React from "react";

export const getSeoImage = (img?: string | null, imageList?: any[] | null): string => {
    if (imageList && imageList.length > 0) {
        for (var i = 0; i < imageList.length; i++) {
            if (imageList[i] && imageList[i]?.url?.trim()?.length) {
                return imageList[i]?.url;
            }
        }
    }

    if (img && img.trim().length > 0) {
        return img;
    }

    return '';
}

export const getSeoText = (value?: string | null): string => {
    if (value && value?.trim().length > 0) {
        if (value.includes("<") && value.includes(">")) {
            const res = value.replace(/<[^>]*>/g, function (entity, entityCode) {
                if (entity?.trim()?.toLowerCase()?.replace(" ", "") == "<br/>" || entity?.trim()?.toLowerCase()?.replace(" ", "") == "<br>") {
                    return '\n';
                }

                return ' ';
            });

            return CleanText(res);
        }
    }

    return CleanText(value);
}

const CleanText = (value?: string | null) => {
    if (value && value?.trim()?.length > 0) {
        let result = replaceAll(value, "&nbsp;", " ").trim();
        result = replaceAll(result, '\n ', '\n').trim();
        //result = replaceAll(result, '\n\n', '\n').trim();
        result = replaceAll(result, ' \n', '\n').trim();

        return result;
    }

    return '';
}

/*
export const getSeoText = (value?: string | null): string => {
    if (value && value?.trim()?.length > 0) {
        const span = document.createElement('span');
        span.innerHTML = RemoveHtmlTags(value);
        return span.innerText;
    }

    return (value ? value : '');
}*/

export const replaceAll = (value: string, search: string, replace: string) => {
    if (value && search && replace && search != replace && value.includes(search)) {
        let x = value;

        do {
            x = x.replace(search, replace);
        }
        while (x.includes(search));

        return x;
    }

    return value;
}